import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GeolocationService } from '../services/geolocation.service';
import { } from '@types/googlemaps';
import { UUID } from 'angular2-uuid';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { Alert } from 'selenium-webdriver';

import { PuntoVisita } from '../Models/PuntoVisita';
import { Zona } from '../Models/Zona';
import { Coordinates } from '../Models/Coordinates';
import { Ruta } from '../Models/Ruta';

import { PuntoVisitaService } from '../services/punto-visita.service';
import { ZonaService } from '../services/zona.service';
import { RutaService } from '../services/ruta.service';
import { GlobalsService } from '../services/globals.service';
import { CompaniaService } from '../services/compania.service';


@Component({
  selector: 'app-punto-visita',
  templateUrl: './punto-visita.component.html',
  styleUrls: ['./punto-visita.component.css']
})
export class PuntoVisitaComponent implements OnInit {

  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;


  @ViewChild('pacinput') buscar: any;
  public autocomplete: google.maps.places.Autocomplete;
  static autocompletevariable: any;

  public punto: PuntoVisita = new PuntoVisita();
  public puntos: PuntoVisita[];

  public zonas: Zona[];
  public rutas: Ruta[];

  public modoEdicion: boolean = false;
  public nuevoRegistro: boolean = false;

  public IdZona: number;
  public IdRuta: number;

  public mostrarMapa: boolean = false;

  //punto mapa
  public latitude: number = 9.935232;
  public longitude: number = -84.102606;
  public markers = [];
  //geocerca
  private cercaCoords = []; //Array de coordenas ordenadas 
  private geoCerca; //Polígono dentro del mapa
  private marcadorCoords = []; //Array de marcadores del polígonos
  private geoCercaCreada: boolean = false;


  // private _el:HTMLElement;
  location = 'default location, update when clicking on the map';


  //grid

  @ViewChild('agGrid') agGrid: AgGridNg2;
  title = 'Puntos de Visita';

  columnDefs = [
    { headerName: 'Nombre', field: 'nombrePunto', icons: { filter: ' ' } },
    { headerName: 'Teléfono', field: 'telefono', icons: { filter: ' ' } },
    { headerName: 'Email', field: 'email', icons: { filter: ' ' } },
    { headerName: 'Zona', field: 'descripcionZona', icons: { filter: ' ' } },
    { headerName: 'Ruta', field: 'descripcionRuta', icons: { filter: ' ' } },
    { headerName: 'Estado', field: 'estado', icons: { filter: ' ' } }

  ];

  rowData: any[];

  constructor(
    private geoService: GeolocationService,
    private puntoVisitaService: PuntoVisitaService,
    private zonaService: ZonaService,
    private rutaService: RutaService,
    private globalServices: GlobalsService,
    private compania: CompaniaService

  ) {

  }

  ngOnInit() {


    this.CargarPuntos();

  }


  cagarMapa() {

    this.map = new google.maps.Map(this.gmapElement.nativeElement, {
      center: {
        lat: this.latitude,
        lng: this.longitude
      },
      zoom: 15
    });

    this.autocomplete = new google.maps.places.Autocomplete(this.buscar.nativeElement, {});
    this.autocomplete.getPlace();
    PuntoVisitaComponent.autocompletevariable = this.autocomplete;



    var input = /** @type {!HTMLInputElement} */(
      this.buscar.nativeElement);
    // this.autocomplete=new google.maps.places.Autocomplete(input);
    var types = document.getElementById('type-selector');
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(types);

    PuntoVisitaComponent.autocompletevariable.addListener('place_changed', this.CargarAutoCompletar.bind(this));

    google.maps.event.addListener(this.map, 'click', this.updateLocation.bind(this));

  }

  //cuando le da clik al mapa para que actualice el punto
  private updateLocation(event) {

    this.DeleteMarkers();

    this.location = event.latLng.toString();

    let loc = event.latLng.toJSON()

    this.punto.longitud = loc.lng;
    this.punto.latitud = loc.lat;


    this.CrearPunto(loc.lat, loc.lng);

  }

  //Cuando detacta en el busca mapa para encontrar la ubicación
  private CargarAutoCompletar(event) {
    this.DeleteMarkers();
    var place = PuntoVisitaComponent.autocompletevariable.getPlace();
    this.map.setCenter(place.geometry.location);
    this.map.setZoom(17);

    var marker = new google.maps.Marker({
      position: place.geometry.location,
      map: this.map,
      title: this.punto.nombreContacto,

    });
    this.markers.push(marker);
  }


  CrearPunto(latitud: number, longitud: number) {
    try {

      var marker = new google.maps.Marker({
        position: { lat: latitud, lng: longitud },
        map: this.map,
        title: this.punto.nombreContacto,

      });

      this.markers.push(marker);

    } catch (error) {

    }
  }

  DeleteMarkers() {
    try {

      //Loop through all the markers and remove
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];

    } catch (error) {

    }

  };

  //carga la latitud y longitud de la compañia
  CargarReferencia() {
    this.compania.ObtenerCompania(this.globalServices.ObtenerCompania()).subscribe(
      data => {

        this.latitude = parseFloat(data.latitud);
        this.longitude = parseFloat(data.logitud);
      },
      err => {
        console.clear();
        console.log(err._body);

      });

  }



  CargarPuntos() {
    try {

      this.puntoVisitaService.ObtenerPuntoVisitas(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.puntos = data;

          this.rowData = this.puntos;
          this.CargarZonas();

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("Cargar puntos: " + error);
    }

  }



  GuardarRegistro() {

    try {

      this.punto.idCompania = this.globalServices.ObtenerCompania();
      this.punto.idZona = this.IdZona;
      this.punto.idRuta = this.IdRuta;

      if (this.punto.idPunto === undefined) {
        this.punto.idPunto = UUID.UUID();
      }


      if (this.punto.estado === undefined) {
        this.punto.estado = 'ACTIVO';
      }

      this.puntoVisitaService.GuardarRegistro(this.punto).subscribe(
        data => {

          swal("Registro guardado con éxito!", "", "success");

          this.punto = new PuntoVisita();
          this.modoEdicion = false;

          this.CargarPuntos();

        },
        err => {
          console.error(err);
          swal("Error al guardar el punto de visita!", "", "error");

        }

      );

    } catch (error) {
      console.log("Guardar Registro: " + error);
    }
  }


  CargarZonas() {
    try {

      this.zonaService.ObtenerZonas(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.zonas = data;

          this.CargarReferencia();

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("Cargarzonas: " + error);
    }
  }


  ZonaSeleccionada() {
    try {

      this.rutaService.ObtenerRutas(this.globalServices.ObtenerCompania(), this.IdZona.toString()).subscribe(
        data => {
          this.rutas = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarRutas:" + error);
    }
  }


  NuevoRegistro() {

    this.IdZona = 0;
    this.IdRuta;


    this.CargarZonas();

    this.nuevoRegistro = true;
    this.punto = new PuntoVisita();
    this.rutas = [];


    this.modoEdicion = true;

    this.mostrarMapa = false;

  }

  CancelarEdicion() {
    this.punto = new PuntoVisita();
    this.modoEdicion = false;
    this.mostrarMapa = false;
    this.limpiarPoligono();
  }

  mostrarEdicion(): boolean {


    if (this.mostrarMapa) {
      return false;
    }


    return this.modoEdicion;
  }

  CapturarGeoCerca() {
    try {

      this.mostrarMapa = false;

    } catch (error) {

    }
  }

  mostrarLocalizacion() {
    try {

      this.cagarMapa();
      this.CrearPunto(parseFloat(this.punto.latitud), parseFloat(this.punto.longitud));

      //geocerca

      // this.rutas .forEach(element => {

      //           if (element.cerca != undefined && (this.punto.idRuta==element.idRuta || this.IdRuta==element.idRuta )){
      //             for (var i = 0; i < element.cerca.length; i++) {
      //               let lati=parseFloat( element.cerca[i].latitud);
      //               let long= parseFloat( element.cerca[i].longitud);
      //               this.cercaCoords.push({ lat: lati, lng: long });
      //             }

      //           }
      //    });


      // this.mostrarPoligono();

      this.mostrarMapa = true;

    } catch (error) {

    }
  }

  //geocerca


  mostrarPoligono() {

    if (this.geoCerca != undefined) {
      this.geoCerca.setMap(null);
    }

    this.geoCerca = new google.maps.Polygon({
      paths: this.cercaCoords,
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 3,
      fillColor: '#FF0000',
      fillOpacity: 0.35
    });
    this.geoCerca.setMap(this.map);

  }


  limpiarPoligono() {
    try {

      this.geoCerca.setMap(null);

      this.cercaCoords = [];

      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];


      //this.ruta.cerca = [];

    } catch (error) {

    }
  }

  //click en el row de la tabla
  private onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    let datos = JSON.parse(JSON.stringify($event.data));

    //Se debe clonar el item para que no afecte el array origen en memoria
    this.nuevoRegistro = false;

    this.punto = datos;

    if (this.punto.latitud === "") {
      this.punto.latitud = undefined;
    }

    if (this.punto.longitud === "") {
      this.punto.longitud = undefined;
    }

    if ((this.punto.latitud != undefined) && (this.longitude != undefined)) {

      this.CrearPunto(parseFloat(this.punto.latitud), parseFloat(this.punto.longitud));
      this.latitude = parseFloat(this.punto.latitud);
      this.longitude = parseFloat(this.punto.longitud);
    }
    else {

      this.CrearPunto(9.935232, -84.102606);
    }

    this.IdZona = this.punto.idZona;

    this.ZonaSeleccionada();



    this.limpiarPoligono();

    //       this.rutas .forEach(element => {

    //         if (element.cerca != undefined){
    //           for (var i = 0; i < element.cerca.length; i++) {
    //             let lati=parseFloat( element.cerca[i].latitud);
    //             let long= parseFloat( element.cerca[i].longitud);
    //             this.cercaCoords.push({ lat: lati, lng: long });
    //           }

    //         }
    //  });

    // for (var i = 0; i < this.ruta.cerca.length; i++) {
    //   let lati=parseFloat( this.ruta.cerca[i].latitud);
    //   let long= parseFloat( this.ruta.cerca[i].longitud);

    //   this.cercaCoords.push({ lat: lati, lng: long });
    // }  


    this.IdRuta = this.punto.idRuta;

    this.modoEdicion = true;

  }


  CancelarGeoCerca() {

    this.mostrarMapa = false;
    this.limpiarPoligono();

  }

}
